/* cl-oc-cart.js — gaveta do carrinho do concorrente (oc-cart.js do tema dele) portada para a NOSSA loja.
   Mesmo markup/CSS (.occ), mesma ordem de blocos: barra de frete gratis, linhas (qtd +/-, remover), "upgrade" do kit,
   "Complete your kit" (cross-sell), total com economia, CTA de checkout, selos e meios de pagamento.
   Diferencas: dados do NOSSO catalogo (config Liquid em #oc-cart-cfg), dinheiro no formato da loja, sem o app
   Moonbundle (o kit vira N unidades + o CODIGO do kit, aplicado aqui via /cart/update.js {discount}), sem o
   "Shipping protection" (produto que a nossa loja nao tem), bolha do header NATIVO do Horizon.
   Abre: icone do carrinho do header, evento cl:cart:open, e qualquer /cart/add feito pela pagina. */
(function () {
  'use strict';
  if (window.__clOcCart) return;
  window.__clOcCart = 1;
  var root = document.getElementById('ocCart');
  if (!root) return;
  var IN = document.getElementById('ocCartIn'), DR = root.querySelector('.occ__dr'), CFG = {};
  try { CFG = JSON.parse(document.getElementById('oc-cart-cfg').textContent); } catch (e) {}
  var TH = CFG.threshold || 10000;                       // frete gratis (centavos da moeda da loja)
  // rw 10-31: kit = app Kaching REAL (desconto automatico do app). Os codigos KIT-* da replica nao sao mais
  // aplicados (syncCodes so REMOVE os que estiverem no carrinho) e o UPGRADE (precos dos codigos) sai.
  var KACHING = true;
  var KITS = CFG.kits || {};                            // handle -> [{q, p, code, n}] (q unidades por p, codigo)
  var PACK = CFG.packs || {};                           // q -> rotulo do pack ("Buy 2, Get 1 FREE")
  var BEN = { 3: 'Get the pack most men choose', 5: 'Get a full week covered', 7: 'Get the best value + a FREE Wash Bag' };
  var XSB = CFG.xsb || {};
  var IC = {
    truck: '<svg viewBox="0 0 24 24"><path d="M3 6.5h11v9H3zM14 10h4l3 3v2.5h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    trash: '<svg viewBox="0 0 24 24"><path d="M4.5 7h15M9.5 7V4.8h5V7M6.5 7l1 12.5h9l1-12.5M10 10.5v6M14 10.5v6"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
    shield: '<svg viewBox="0 0 24 24"><path d="M12 3 4.5 6v6c0 4.6 3.2 7.6 7.5 9 4.3-1.4 7.5-4.4 7.5-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/></svg>',
    box: '<svg viewBox="0 0 24 24"><path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4z"/><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9"/></svg>'
  };
  var cart = null, nf = window.fetch.bind(window);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // formato de dinheiro da loja ("R$ {{amount_with_comma_separator}}")
  function money(c) {
    var f = CFG.money || '${{amount}}';
    var n = (c || 0) / 100;
    function grp(x, t, d) { var s = x.toFixed(2).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + d + s[1]; }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_with_comma_separator') return grp(n, '.', ',');
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return grp(n, ',', '.');
    });
  }
  function img(u) { return u ? '<img src="' + esc(u) + '" alt="">' : '<span class="occ__noimg"></span>'; }
  function json(r) { return r.json().catch(function () { return {}; }).then(function (j) { return r.ok ? j : Promise.reject(j || {}); }); }

  var inflight = 0;
  function api(path, body) {
    inflight++;
    return nf(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-OC': '1' }, body: JSON.stringify(body) })
      .then(json).then(function (j) { inflight--; return j; }, function (e) { inflight--; return Promise.reject(e); });
  }
  function fail(e) { toast(e && (e.description || e.message) || 'Something went wrong. Please try again.'); }
  var tT = null;
  function toast(m) {
    var t = root.querySelector('.occ__toast');
    if (!t) { t = document.createElement('div'); t.className = 'occ__toast'; t.setAttribute('role', 'status'); DR.appendChild(t); }
    t.textContent = m; t.classList.add('on'); clearTimeout(tT);
    tT = setTimeout(function () { t.classList.remove('on'); }, 3500);
  }

  function fromAjax(c) {
    return {
      item_count: c.item_count || 0, total: c.total_price || 0, codes: (c.discount_codes || []),
      items: (c.items || []).map(function (i) {
        var o = i.options_with_values || [];
        return { key: i.key, variant_id: i.variant_id, handle: i.handle, title: i.product_title,
          o1: o[0] ? o[0].value : '', o2: o[1] ? o[1].value : '', img: i.image, url: i.url, qty: i.quantity,
          price: i.original_price, compare: Math.max(i.original_price, (CFG.cmp || {})[i.variant_id] || 0),
          final: i.final_line_price, disc: (i.line_level_discount_allocations || []).map(function (x) { return x.discount_application && x.discount_application.title; }) };
      })
    };
  }

  /* ---- codigo do kit: maior faixa atingida por produto (o preco do kit exibido na PDP) ---- */
  function wantedCodes(c) {
    if (KACHING) return [];
    var qty = {}, out = [];
    c.items.forEach(function (i) { qty[i.handle] = (qty[i.handle] || 0) + i.qty; });
    Object.keys(qty).forEach(function (h) {
      var best = null;
      (KITS[h] || []).forEach(function (t) { if (t.code && qty[h] >= t.q && (!best || t.q > best.q)) best = t; });
      if (best) out.push(best.code);
    });
    if (CFG.bagCode && CFG.bag && qty[CFG.bag] && uwQty(c) >= 7) out.push(CFG.bagCode);
    return out;
  }
  function uwQty(c) { var n = 0; c.items.forEach(function (i) { if (CFG.uw && CFG.uw.indexOf(i.handle) >= 0) n += i.qty; }); return n; }
  var codeBusy = false;
  function syncCodes(raw) {
    if (codeBusy) return Promise.resolve(null);
    var c = fromAjax(raw);
    var kitCodes = []; Object.keys(KITS).forEach(function (h) { KITS[h].forEach(function (t) { if (t.code) kitCodes.push(t.code.toUpperCase()); }); });
    if (CFG.bagCode) kitCodes.push(CFG.bagCode.toUpperCase());
    var cur = (raw.discount_codes || []).map(function (d) { return (d.code || '').toUpperCase(); });
    var keep = cur.filter(function (x) { return kitCodes.indexOf(x) < 0; });      // codigo digitado pelo cliente fica
    var want = keep.concat(wantedCodes(c).map(function (x) { return x.toUpperCase(); }));
    if (cur.slice().sort().join(',') === want.slice().sort().join(',')) return Promise.resolve(null);
    codeBusy = true;
    return api('/cart/update.js', { discount: want.join(',') }).then(function (j) { codeBusy = false; return j; }, function () { codeBusy = false; return null; });
  }

  var seq = 0;
  function load() {
    var my = ++seq;
    return nf('/cart.js', { headers: { 'Accept': 'application/json', 'X-OC': '1' } }).then(json)
      .then(function (raw) { return syncCodes(raw).then(function (j) { return j && j.items ? j : raw; }); })
      .then(function (raw) {
        if (my !== seq) return null;
        cart = fromAjax(raw); setCount(cart.item_count); return cart;
      });
  }

  function setCount(n) {
    bubble(n); timer(n);
    var h3 = root.querySelector('.occ__h h3');
    if (h3) { var v = 'Cart' + (n ? ' <span class="occ__n">• ' + n + '</span>' : ''); if (h3.innerHTML !== v) h3.innerHTML = v; }
  }
  // bolha do header NATIVO do Horizon (cart-icon): o renderCartBubble liga/desliga, o numero e escrito aqui
  function bubble(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[ref="cartBubbleCount"]'), function (e) { e.textContent = n; });
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') { try { icon.renderCartBubble(n, true); } catch (e) {} }
  }

  function groups() {
    var G = {}, order = [];
    cart.items.forEach(function (it) { if (!G[it.handle]) { G[it.handle] = []; order.push(it.handle); } G[it.handle].push(it); });
    return order.map(function (h) { return { handle: h, lines: G[h] }; });
  }
  var lastH = '';
  function paint(h) {
    if (h === lastH) return;
    lastH = h;
    var b = IN.querySelector('.occ__body'), c = IN.querySelector('.occ__car');
    var st = b ? b.scrollTop : 0, sl = c ? c.scrollLeft : 0;
    var fe = document.activeElement, fk = fe && IN.contains(fe) ? fe.getAttribute('data-fk') : null;
    IN.innerHTML = h;
    var b2 = IN.querySelector('.occ__body'), c2 = IN.querySelector('.occ__car');
    if (b2 && st) b2.scrollTop = st;
    if (c2 && sl) c2.scrollLeft = sl;
    if (fk) { var n = IN.querySelector('[data-fk="' + fk + '"]'); if (n) n.focus({ preventScroll: true }); }
  }

  function render() {
    if (!cart) return;
    if (!cart.items.length) { paint(empty()); return; }
    var sub = cart.total, left = TH - sub, h = '';
    h += (left > 0
      ? '<div class="occ__prog"><p>' + IC.truck + "<span>You're <b>" + money(left) + '</b> away from <b>free shipping</b></span></p>'
      : '<div class="occ__prog is-ok"><p><span class="occ__ck">' + IC.check + "</span><span><b>Congrats!</b> You've unlocked <b>FREE shipping</b></span></p>")
      + '<div class="occ__bar"><i style="width:' + Math.max(0, Math.min(100, sub / TH * 100)) + '%"></i></div></div>';
    h += '<div class="occ__body">';
    var cmpAll = 0, upHtml = '', hasUW = false, G = groups();
    G.forEach(function (g) {
      var isUW = CFG.uw && CFG.uw.indexOf(g.handle) >= 0;
      if (isUW) hasUW = true;
      if (KACHING || upHtml || !isUW || !KITS[g.handle]) return;
      var q = g.lines.reduce(function (a, l) { return a + l.qty; }, 0);
      var fin = g.lines.reduce(function (a, l) { return a + l.final; }, 0);
      var nt = KITS[g.handle].filter(function (t) { return t.q > q && t.q > 1; })[0];
      if (!nt || q <= 0) return;
      var dx = Math.max(0, nt.p - fin);
      var ben = (BEN[nt.q] || '') + (sub < TH && sub + dx >= TH ? ' + FREE shipping' : '');
      upHtml = '<div class="occ__up"><div class="occ__up-m"><b>Add ' + (nt.q - q) + ' more pair' + (nt.q - q > 1 ? 's' : '') + '</b><span>' + esc(nt.n || PACK[nt.q] || '') +
        '</span></div><button class="occ__up-b" data-fk="up" data-up="' + esc(g.lines[0].key) + '" data-add-q="' + (nt.q - q) + '" data-vid="' + g.lines[0].variant_id + '">UPGRADE</button>' +
        '<div class="occ__up-r">' + IC.check + '<span>' + (dx > 0 ? 'Just <b>+' + money(dx) + '</b> · ' : '<b>FREE</b> · ') + ben + '</span></div></div>';
    });
    cart.items.slice().sort(function (a, b) { return (a.final > 0 ? 0 : 1) - (b.final > 0 ? 0 : 1); }).forEach(function (l) {
      var vtx = [l.o1, l.o2].filter(function (x) { return x && x !== 'Default Title'; }).join(' · ');
      var cmpL = Math.max(l.compare || 0, l.price) * l.qty;
      cmpAll += cmpL;
      var tags = (l.disc || []).filter(Boolean).map(function (t) { return String(t).toUpperCase(); });
      if (l.final === 0 && !tags.length) tags = ['FREE'];
      var k = esc(l.key);
      var qs = '<div class="occ__qs"><button data-fk="m' + k + '" data-qk="' + k + '" data-d="-1" aria-label="Decrease quantity">−</button><span aria-live="polite">' + l.qty +
        '</span><button data-fk="p' + k + '" data-qk="' + k + '" data-d="1" aria-label="Increase quantity">+</button></div>';
      var uw = CFG.uw && CFG.uw.indexOf(l.handle) >= 0;
      h += '<div class="occ__li' + (l.final === 0 ? ' occ__li--free' : '') + '" data-line="' + k + '"><a class="occ__img" href="' + esc(l.url) + '" tabindex="-1">' + img(l.img) + '</a>' +
        '<div class="occ__m"><div class="occ__t"><b>' + esc(l.title) + '</b><button class="occ__del" data-fk="r' + k + '" data-rm="' + k + '" aria-label="Remove ' + esc(l.title) + '">' + IC.trash + '</button></div>' +
        (vtx ? '<div class="occ__var">' + esc(vtx) + (uw && l.final > 0 ? ' · <a href="' + esc(l.url) + '">Change</a>' : '') + '</div>' : '') +
        '<div class="occ__pr"><b class="' + (l.final === 0 ? 'occ__fr' : '') + '">' + (l.final === 0 ? 'FREE' : money(l.final)) + '</b>' + (cmpL > l.final ? '<s>' + money(cmpL) + '</s>' : '') + '</div>' +
        '<div class="occ__row">' + qs + (tags.length ? '<div class="occ__tags">' + tags.map(function (t) { return '<span class="occ__tag">' + esc(t) + '</span>'; }).join('') + '</div>' : '') + '</div></div></div>';
    });
    h += upHtml;
    if (hasUW) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.handle] = 1; });
      var xs = (CFG.xs || []).filter(function (x) { return !inCart[x.handle] && x.vid; });
      if (xs.length) {
        h += '<div class="occ__sec"><span>Complete your kit</span><span class="occ__nav"><button data-car="-1" aria-label="Previous">‹</button><button data-car="1" aria-label="Next">›</button></span></div><div class="occ__car">';
        xs.forEach(function (x) {
          var off = x.compare > x.price ? Math.round((x.compare - x.price) / x.compare * 100 / 5) * 5 : 0;
          h += '<div class="occ__ci">' + (off ? '<em class="occ__off">' + off + '% OFF</em>' : '') + img(x.img) + '<b>' + esc(x.title) + '</b><span>' + esc(XSB[x.handle] || '') +
            '</span><div class="occ__pr"><b>' + money(x.price) + '</b>' + (off ? '<s>' + money(x.compare) + '</s>' : '') + '</div><button class="occ__add" data-fk="a' + x.vid + '" data-add="' + x.vid + '">+ ADD</button></div>';
        });
        h += '</div>';
      }
    }
    h += '</div>';
    var tot = cart.total, save = cmpAll - tot;
    h += '<div class="occ__ft"><div class="occ__sr"><span class="occ__sr-l">Total</span>' + (save > 0 ? '<span class="occ__sr-s">Save ' + money(save) + '</span>' : '') +
      '<span class="occ__sr-p">' + (save > 0 ? '<s>' + money(tot + save) + '</s>' : '') + '<b>' + money(tot) + '</b></span></div>' +
      '<a class="occ__cta" href="' + (CFG.checkout || '/checkout') + '">' + IC.lock + '<span>SECURE CHECKOUT</span></a>' + trust() + '</div>';
    paint(h);
  }
  function trust() {
    return '<div class="occ__trust"><div>' + IC.star + '<span><b>4.8/5</b>8,516 reviews</span></div><div>' + IC.shield + '<span><b>30-day</b>guarantee</span></div><div>' +
      IC.box + '<span><b>Discreet</b>package</span></div></div>';
  }
  function empty() {
    var h = '<div class="occ__ec"><b>Your cart is empty</b><p>Start with our best sellers.</p></div><div class="occ__body"><div class="occ__bs">';
    (CFG.bs || []).forEach(function (x) {
      var pr = x.price * (x.p || 1), cp = (x.compare || x.price) * (x.c || 1);
      if (x.kp) pr = x.kp;
      h += '<div class="occ__bsi">' + img(x.img) + '<div class="occ__m"><b>' + esc(x.title) + '</b><span>' + esc(x.n || '') + '</span><div class="occ__pr"><b>' + money(pr) + '</b>' +
        (cp > pr ? '<s>' + money(cp) + '</s>' : '') + '</div></div><a class="occ__add" href="' + esc(x.url) + '">SHOP</a></div>';
    });
    return h + '</div></div><div class="occ__ft"><a class="occ__cta" href="' + (CFG.all || '/collections/all') + '"><span>SHOP ALL</span></a>' + trust() + '</div>';
  }

  /* ---- reserva de 10 min (o tema dele mostra com itens no carrinho) ---- */
  var TMK = 'oc_reserved_until', tmI = null;
  function timer(n) {
    var el = document.getElementById('ocTimer');
    if (!el) return;
    // "Your cart is reserved for 10:00" dele e um cronometro de urgencia falso (a Shopify nao reserva carrinho): fica oculto
    if (!CFG.reserveTimer) { el.hidden = true; return; }
    if (!n) { el.hidden = true; clearInterval(tmI); tmI = null; return; }
    var until = 0;
    try { until = +localStorage.getItem(TMK) || 0; } catch (e) {}
    if (!until || until < Date.now()) { until = Date.now() + 6e5; try { localStorage.setItem(TMK, until); } catch (e) {} }
    el.hidden = false;
    if (tmI) return;
    function tick() {
      var u = 0;
      try { u = +localStorage.getItem(TMK) || until; } catch (e) { u = until; }
      var ms = u - Date.now();
      if (ms <= 0) { u = Date.now() + 6e5; try { localStorage.setItem(TMK, u); } catch (e) {} ms = 6e5; }
      var m = Math.floor(ms / 6e4), s = Math.floor(ms % 6e4 / 1e3), v = document.getElementById('ocTimerV');
      if (v) v.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick(); tmI = setInterval(tick, 1e3);
  }

  var running = false, pend = false;
  function after() {
    if (running) { pend = true; return Promise.resolve(); }
    running = true;
    return load().then(function (c) { if (c) render(); }).catch(function () {}).then(function () {
      running = false;
      if (pend && !inflight) { pend = false; return after(); }
    });
  }
  function done() { if (inflight) { pend = true; return; } lastH = ''; after(); }

  var qT = {};
  function changeQty(key, d, btn) {
    var li = btn.closest('.occ__li'), sp = li && li.querySelector('.occ__qs span');
    if (!sp) return;
    var nq = Math.max(0, (+sp.textContent || 0) + d);
    sp.textContent = nq;
    if (nq === 0) li.style.display = 'none';
    clearTimeout(qT[key]);
    qT[key] = setTimeout(function () {
      delete qT[key];
      api('/cart/change.js', { id: key, quantity: nq }).then(done, function (e) { fail(e); done(); });
    }, 350);
  }

  IN.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rm],[data-qk],[data-up],[data-add],[data-car]');
    if (!t) return;
    if (t.dataset.car) {
      var c = IN.querySelector('.occ__car');
      if (c) c.scrollBy({ left: +t.dataset.car * c.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    e.preventDefault();
    if (t.dataset.rm) {
      var li = t.closest('.occ__li');
      if (li) { li.style.transition = 'opacity .15s'; li.style.opacity = '0'; setTimeout(function () { li.style.display = 'none'; }, 150); }
      var u = {}; u[t.dataset.rm] = 0;
      api('/cart/update.js', { updates: u }).then(done, function (er) { fail(er); done(); });
    } else if (t.dataset.qk) changeQty(t.dataset.qk, +t.dataset.d, t);
    else if (t.dataset.up) {
      t.disabled = true;
      api('/cart/add.js', { items: [{ id: +t.dataset.vid, quantity: +t.dataset.addQ }] }).then(done, function (er) { fail(er); done(); });
    } else if (t.dataset.add) {
      t.disabled = true;
      api('/cart/add.js', { items: [{ id: +t.dataset.add, quantity: 1 }] }).then(done, function (er) { fail(er); done(); });
    }
  });

  var sy = 0, locked = false, prevFocus = null;
  function lock() {
    if (locked) return;
    locked = true; sy = window.scrollY || 0;
    document.documentElement.classList.add('cl-cart-open');
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('cl-cart-open');
  }
  function openCart() {
    var was = root.classList.contains('is-open');
    if (!was) { lock(); prevFocus = document.activeElement; }
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (!was) { var x = root.querySelector('.occ__x'); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50); }
    lastH = ''; after();
  }
  function closeCart() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    unlock();
    if (prevFocus && prevFocus.focus) { try { prevFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
    var f = [].filter.call(DR.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  root.addEventListener('click', function (e) { if (e.target === root || e.target.closest('[data-occ-close]')) closeCart(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  document.addEventListener('cl:cart:open', openCart);
  // icone do carrinho do header nativo (cart-icon / link /cart)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], cart-icon, .header-actions__cart-icon, [data-cl-cart-toggle]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); e.stopImmediatePropagation(); openCart();
  }, true);
  window.ocCart = { open: openCart, close: closeCart, refresh: after };

  // qualquer /cart/add da pagina (form do produto, cards, bump) abre a gaveta; mudancas atualizam a bolha
  var lastAct = 0;
  ['pointerdown', 'keydown', 'submit'].forEach(function (t) { document.addEventListener(t, function (e) { if (e.isTrusted) lastAct = Date.now(); }, true); });
  function userAdd() { return Date.now() - lastAct < 5e3; }
  function syncBubble() {
    nf('/cart.js', { headers: { 'Accept': 'application/json', 'X-OC': '1' } }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { setCount(c.item_count || 0); syncCodes(c); } }).catch(function () {});
  }
  window.fetch = function (input, init) {
    var url = typeof input == 'string' ? input : (input && input.url) || '';
    var hd = init && init.headers, mine = hd && (hd['X-OC'] || (hd.get && hd.get('X-OC')));
    var p = nf(input, init);
    if (!mine && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      var ua = userAdd();
      p.then(function (r) { if (r.ok) { if (ua) setTimeout(openCart, 150); else syncBubble(); } }, function () {});
    } else if (!mine && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) syncBubble(); }, function () {});
    }
    return p;
  };
  // o form do produto (ATC do tema) vai por aqui: /cart/add.js e a gaveta abre
  window.clCartPost = function (path, fd) {
    return nf(path, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-OC': '1' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  };
  setTimeout(syncBubble, 1500);
})();
